
import Vue from "vue";
import Employee from "@/interface/Employee";
import { EmployeesApi } from "@/api";
import GenericButton from "@/components/GenericButton.vue";
import LeftArrowIcon from "@/components/icons/LeftArrowIcon.vue";
import ProgressButton from "@/components/ProgressButton.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";

declare interface ComponentData {
  employee: Employee;
  deleted: boolean;
  loading: boolean;
  error: Error;
}

export default Vue.extend({
  name: "EmployeeView",
  data(): ComponentData {
    return {
      employee: {} as Employee,
      deleted: false,
      loading: true,
      error: {} as Error,
    };
  },
  async created() {
    // get employee by passed id
    await EmployeesApi.getById(this.$route.params.id)
      .then((employee) => {
        this.employee = employee;
      })
      .catch((error) => {
        this.error = error;
      })
      .then(() => {
        this.loading = false;
      });
  },
  methods: {
    // "delete" the current employee
    deleteEmployee(): void {
      this.loading = true;
      EmployeesApi.deleteById(this.employee.id)
        .then((response) => {
          if (response.status === 200) {
            this.deleted = true;
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  components: {
    ProgressButton,
    LeftArrowIcon,
    GenericButton,
    LoadingIndicator,
  },
});
